import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { LoadingController, MenuController, NavController, Platform } from '@ionic/angular';
import { Toast, ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { PlatformService } from 'src/app/services/platformbase.service';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/services/common-services/shared.service';
import { ThemeService } from 'src/app/services/theme.service';
import { LoginModel } from 'src/app/models/Login/login.model';
import { FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/services/common-services/common.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
@Component({
  selector: 'app-travel-eva',
  templateUrl: './travel-eva.component.html',
  styleUrls: ['./travel-eva.component.scss'],
})
export class TravelEvaComponent implements OnInit {
  xrayUrl: any;
  fc365url: any;
  token: any;
  makemytripUrl: any;
  userInfo: any;
  platformType: any;
  ssoLogin: boolean = false;
  apiKey: string;
  loginModel = new LoginModel();
  submitted = false;
  loginForm: FormGroup;
  buttonDisabled = false;
  isAndroidIOS: any;
  options: InAppBrowserOptions = {
  location: 'yes',   // Show address bar
    toolbar: 'no',     // No toolbar
    zoom: 'yes',       // Allow zooming
    clearcache: 'yes', // Clear cache
    clearsessioncache: 'yes', // Clear session cache
  };
  constructor(private sanitizer: DomSanitizer,
    private theInAppBrowser: InAppBrowser,
    private route: ActivatedRoute,
    private angularRouter: Router,
    private platform: PlatformService,
    private loadingController: LoadingController,
    public router: NavController,
    private sharedService: SharedService,
    private theme: ThemeService,
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    public toaster: ToastrService,
     public menuCtrl: MenuController,
     private platformService: PlatformService,
  ) {
    this.loading();
  }

  ngOnInit() {
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.platformType = this.platform.isAndroidIOS();
    this.isAndroidIOS = this.platformService.isAndroidIOS();
    let fc365url;
    if (this.platformType == 2) {
      fc365url = environment.xray_domain + this.userInfo?.ssoTokenForXray;
    } else {
      this.fc365url = JSON.parse(localStorage.getItem('fc365url'))
    }

    window.addEventListener("message", this.handleMessageEvent.bind(this), false);

    this.xrayUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fc365url);
    if (this.angularRouter.url.match(/itinerary/g)) {
      this.token = this.angularRouter.url;
      if (this.token) {
        this.makemytripUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.xray_base + this.token);
      }
    }
    //  this.xrayUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    //   JSON.parse(localStorage.getItem('fc365url'))
    // );

  }



  async loading() {
    const loading = await this.loadingController.create({
      message: `loading...`,
      duration: 5000
    });
    await loading.present();
  }
  handleMessageEvent(event: MessageEvent) {
    // console.log(event);

     if (event.data.type === 'pdfFile') {
      const testUrl = event.data.url.trim(); // Make sure it's a full URL
      // if(this.platformService.isAndroid()) {
        window.open(testUrl, '_blank'); // Use default system browser
      // } else {
        this.theInAppBrowser.create(testUrl, '_system', this.options);
      // }
    }

    if (event.data.makemytripurl) {
      this.toaster.success(event.data.makemytripurl);
      this.theInAppBrowser.create(event.data.makemytripurl, '_system', 'location=yes');

    }
    
    if (event.data.type === 'expenses') {
      if (event.data.ssoLogin) {
        this.ssoLogin = true;
        this.apiKey = event.data.ssoLogin;
        this.loginModel.token = this.apiKey;
        this.formSubmit();
      }

    }
    if (event.data.type === 'logout') {
      //logout code
      this.router.navigateRoot(["login"]);
      sessionStorage.clear();
      localStorage.clear();
      this.sharedService.setUserInfo(false);
      this.sharedService.setRefreshData(false);
      this.sharedService.setExpenseData(null);
      this.sharedService.setCompanyInfo(null);
      this.sharedService.setMapData(null);
      this.sharedService.setPreCategory(null);
      this.sharedService.setPeningApprovalCount(null);
      this.theme.applyTheme(null);

    }

   
    //  window.open(event.data.makemytripurl, '_system');
    // event.data.type ==''
  }
 formSubmit() {
        this.submitted = true;
        if (this.ssoLogin) {
            this.loginModel.email = null;
            this.loginModel.password = null;

            // this.loginModel.token = 'oQnFxDTW4iqd--zwfCOmNfkWptY14D--qFPfN7q5uo9j6OwlRqLRt--EqSOGG4cZ+4SQGd5cDgQtKj2c3f4BuH1nynHUiA2Xf5rUpn0Za2TRRN0MrmHyfpjkdnjlNmYlBWWyeBA5pIETYJLr2viEsMiHYmrhjoLgXITjAioIQZHQq0='
        } else {
            if (!this.loginForm.valid) {
                return;
            }
        }
        this.buttonDisabled = true;
        let obj = JSON.parse(JSON.stringify({ ...this.loginModel }));
     
           this.authenticationService.authenticateUser(obj).subscribe(res => {
            if (!res.isError && res.errorCode === 0 && res.payload) {
                if(res?.payload?.maintenanceCode == 1 || res?.payload?.maintenanceCode == 2) {
                    this.sharedService.setMaintenanceflag(true);
                }
                sessionStorage.setItem("isAuthenticated", JSON.stringify(true));
                sessionStorage.setItem("isAttachmentMandatory", JSON.stringify(res?.payload?.isAttachmentMandatory));
                // localStorage.setItem("isAttachmentMandatory", JSON.stringify(res.payload.isAttachmentMandatory));
                sessionStorage.setItem("userInfo", JSON.stringify(res.payload));
                localStorage.setItem("userInfo", JSON.stringify(res.payload));
                // this.sharedService.setUserInfo(true);
                this.menuCtrl.enable(true, 'mainMenu');
                this.menuCtrl.enable(false, 'settingMenu');
                // this.isRememberedMe();
                this.buttonDisabled = false;
                sessionStorage.setItem("current-lang", res.payload.baseLanguage);
                this.authenticationService.status.next(true);
                this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                // this.getperdiemstatus(this.userInfo);

                const obj = {
                    primary: res.payload.primaryColor,
                    secondary: res.payload.secondaryColor,
                    fontFamily: res.payload.font
                };
                sessionStorage.setItem('theme', JSON.stringify(obj));
                this.theme.applyTheme(obj);
                if (res.payload.forceChangePassword) {
                    this.router.navigateRoot(['changepassword']);
                } else {
                    //this.router.navigateRoot(['dashboard']);
                    // console.log('isAndroidIOS _________ ', this.isAndroidIOS);
                    if (this.isAndroidIOS == 1) {
                        this.router.navigateRoot(['dashboard']);
                    } else if (this.isAndroidIOS == 2) {
                        sessionStorage.setItem("isadmin", JSON.stringify(false));
                        this.sharedService.setUserToggle(!false);
                        // this.router.navigateRoot(['camera']); //murthySir changes
                        if (environment.appLogo == "fc365") {
                            let fc365Obj = res.payload.appsUrl;
                            if (fc365Obj) {
                                let obj365url = fc365Obj[0].value;
                                localStorage.setItem('fc365', JSON.stringify(true));
                                localStorage.setItem('fc365url', JSON.stringify(obj365url));
                                
                                let AppType = 1;
                                // const modules = res.payload.appsUrl || [];

                                // Check if Travel exists
                                const hasTravel = res.payload.appsUrl?.some(item => item.key === "Travel" && item.value !== null);

                                // Check if Expenses exists
                                const hasExpenses = true; //res.payload.appsUrl?.some(item => item.key === "Expenses" && item.value !== null);

                                // Set AppType based on conditions
                                if (hasTravel && hasExpenses) {
                                AppType = 1; // Both Travel and Expenses
                                } else if (hasTravel && !hasExpenses) {
                                AppType = 2; // Only Travel
                                } else if (!hasTravel && hasExpenses) {
                                AppType = 3; // Only Expenses
                                }


                                let DefaultApp = res.payload?.defaultApp ? res.payload?.defaultApp :  'expenses'

                                if(AppType == 1) {
                                    if(DefaultApp == 'travel') {
                                        this.router.navigateRoot(['traveleva']);
                                    }else {
                                        this.router.navigateRoot(['dashboard']);
                                    }
                                    // this.router.navigateRoot(['dashboardfc365']);
                                }else if(AppType == 2) {
                                    this.router.navigateRoot(['traveleva']);
                                }else if(AppType == 3) {
                                    this.router.navigateRoot(['dashboard']);
                                }

                                // let obj365url = fc365Obj[0].value;
                                // localStorage.setItem('fc365', JSON.stringify(true));
                                // localStorage.setItem('fc365url', JSON.stringify(obj365url));
                                // this.router.navigateRoot(['dashboardfc365']);
                            } else {
                                this.router.navigateRoot(['dashboard']);
                            }
                        } else {
                            this.router.navigateRoot(['dashboard']);
                        }

                        this.sharedService.setUserInfo(true);

                    }
                }
            } else if (res.isError && res.errorCode === 2) {
                this.buttonDisabled = false;
                this.toaster.error(res.errorMessage, 'Error');
            }
        });
        


       
    }
   
  ngOnDestroy() {
    // Clean up event listener
    window.removeEventListener('message', this.handleMessageEvent);
  }

}